import IconButton from "@mui/material/IconButton";
import FileOpenIcon from '@mui/icons-material/FileOpen';
import Tooltip from "@mui/material/Tooltip";
import Button, { ButtonProps } from "@mui/material/Button";
import { SxProps, Theme } from "@mui/material/styles";
import { SvgIconProps } from "@mui/material/SvgIcon";
import { APIContext } from "../Contexts/APIContext";
import { useContext } from "react";
import { TelemetryContext } from "../Contexts/TelemetryContext";


interface IProps {
    label?: string;
    container: string;
    file: string;
    buttonVariant?: ButtonProps['variant'];
    buttonSize?: ButtonProps['size'];
    tooltip?: string;
    iconColor?: SvgIconProps['color'];
    iconButtonSx?: SxProps<Theme>;
}

export default function PDFLink(props: IProps) {
    const { getPDF } = useContext(APIContext);
    const { logFileAccess } = useContext(TelemetryContext);

    const getFile = () => {
        logFileAccess(props.file, "PDFLink");
        getPDF(
            'Document',
            `GetLibraryFile?folder=${props.container}&fileName=${props.file}`,
            props.label ?? props.file,
            true
        );
    };

    return (
        <Tooltip title={props.tooltip ?? "Open Information Document"}>
            {props.label ?
                <Button onClick={getFile} variant={props.buttonVariant} size={props.buttonSize}>{props.label}</Button>
                :
                <IconButton onClick={getFile} size="small" sx={props.iconButtonSx} aria-label={props.tooltip ?? `Open ${props.file}`}>
                    <FileOpenIcon color={props.iconColor ?? "info"} />
                </IconButton>
            }
        </Tooltip>
    );
}
